"use client";
import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import { useWishlist } from "../context/WishlistContext"; // Adjust path
import { img } from 'framer-motion/client';
 
function ProductCard({ product, id, imgUrl, title, price, offer_price, hasWishlist = false, className = "", onClick }) {

  const originalPrice = Number(price) || 0;
  const discountedPrice = Number(offer_price) || 0;

  const hasDiscount =
    discountedPrice > 0 && discountedPrice < originalPrice;

  const discountPercent = hasDiscount
    ? Math.round(((originalPrice - discountedPrice) / originalPrice) * 100)
    : 0;
      
  const { addToWishlist, removeFromWishlist, isInWishlist } = useWishlist();
 
 
  const isWishlisted = isInWishlist(id);
  // console.log("Product data in ProductCard:", product);
 
  const toggleWishlist = (event) => {
    event.stopPropagation(); // Prevent triggering product click
    const productData = { id, imgUrl, name: title, price };
    if (isWishlisted) {
      removeFromWishlist(id);
    } else {
      addToWishlist(product);
    }
  };
 
  const handleProductClick = () => {
    if (onClick) {
      onClick();
    }
  };
 
 
  return (
    <article className={`w-full ${className}`}>
      <div className="relative w-full">
        <div
          className="block w-full cursor-pointer hover:opacity-90 transition-opacity"
          onClick={handleProductClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleProductClick();
            }
          }}
          aria-label={`View details for ${title}`}
        >
          <div
  className="w-full bg-white aspect-[0.67] bg-cover bg-top"
  style={{ backgroundImage: `url(${imgUrl})` }}
  role="img"
  aria-label={title}
/>
 
          <div className="px-2 mt-2.5 w-full font-medium text-neutral-700">
            <div className="py-1 w-full text-xs">
              <h3 className="font-medium text-neutral-700 line-clamp-2">{title}</h3>
            </div>
            <div className="flex items-center gap-2 mt-1">
            {/* Selling Price */}
            <span className="text-sm font-semibold text-neutral-900">
              ₹ {hasDiscount ? discountedPrice : originalPrice}
            </span>

            {/* Original Price */}
            {hasDiscount && (
              <span className="text-xs text-neutral-400 line-through">
                ₹ {originalPrice}
              </span>
            )}

            {/* Discount */}
            {hasDiscount && (
              <span className="text-xs font-semibold text-green-600">
                {discountPercent}% OFF
              </span>
            )}
          </div>
          </div>
        </div>
        <button
          className="absolute top-4 right-4 p-1 bg-transparent rounded-full shadow-md hover:shadow-lg transition-shadow z-10"
          aria-label="Add to wishlist"
          onClick={toggleWishlist}
        >
          <Heart
            size={30}
            strokeWidth={1}
            className={`transition-colors ${
              isWishlisted
                ? 'fill-red-500 text-red-500'
                : 'text-red-400 hover:text-red-400'
            }`}
          />
        </button>
      </div>
    </article>
  );
}
 
export default ProductCard;